import React from 'react'
import ReactDOM from 'react-dom'
import { IntlProvider } from 'react-intl'
import { ThemeProvider } from 'styled-components'

import App from './App'
import SuspenseErrorBoundary from './components/SuspenseErrorBoundary'
import { SetupApp } from './components/SetupApp'
import { UnsupportedBrowser } from './components/UnsupportedBrowser'
import * as serviceWorkerRegistration from './service-worker-registration'
import { isBrowserSupported } from './utils/is-browser-supported'
import messagesEN from './i18n/en.json'
import { AppTheme, GlobalFonts, PORTAL_DEFAULT_THEME } from './components/Global'
import { sanitizeTheme } from './utils/sanitizeTheme'

function getNodeToRender() {
  if (!isBrowserSupported()) {
    return (
      <IntlProvider
        defaultLocale="en"
        locale={navigator.language.split('-')[0] || 'en'}
        messages={messagesEN}
      >
        <ThemeProvider theme={sanitizeTheme(PORTAL_DEFAULT_THEME)}>
          <GlobalFonts />
          <AppTheme />
          <UnsupportedBrowser />
        </ThemeProvider>
      </IntlProvider>
    )
  }

  return (
    <React.StrictMode>
      <SetupApp>
        <SuspenseErrorBoundary>
          <App />
        </SuspenseErrorBoundary>
      </SetupApp>
    </React.StrictMode>
  )
}

function render() {
  const nodeToRender = getNodeToRender()
  ReactDOM.render(nodeToRender, document.getElementById('root'))
}

render()

serviceWorkerRegistration.register()
